import type { Reducer } from 'redux';
import { isDEV } from '@/utils/Location';
import { Actions } from '@/redux/auth/actions';
import type { MCDApplication } from '@/services/app/types';
import type { AuthState, AuthAction } from '@/redux/auth/types';

const mcdApplication = (window as MCDApplication).mcd || isDEV();

const refreshExpiresAt = localStorage.getItem('refreshExpiresAt');
const accessExpiresAt = localStorage.getItem('accessExpiresAt');

const refreshToken = localStorage.getItem('refreshToken');
const accessToken = localStorage.getItem('accessToken');

const accessExpiration = (accessExpiresAt && +accessExpiresAt) || null;
const refreshExpiration = (refreshExpiresAt && +refreshExpiresAt) || null;

export const initialState = (
  !mcdApplication
    ? {
        refreshExpiresAt: refreshExpiration,
        accessExpiresAt: accessExpiration,
        refreshToken,
        accessToken
      }
    : {
        refreshExpiresAt: null,
        accessExpiresAt: null,
        refreshToken: null,
        accessToken: null
      }
) as AuthState;

export default ((state = initialState, action: AuthAction) => {
  switch (action.type) {
    case Actions.SetAuthData:
      return { ...state, ...action.data };

    case Actions.SetAuthDataFail:
      return { ...state, error: action.error };

    default:
      return state;
  }
}) as Reducer<AuthState, AuthAction>;
